/**
 * Headers for the AI server (institute + user).
 * AIChat sets session ids so other callers (tools, studio, copy) inherit them.
 */

let sessionInstituteId = '';
let sessionUserId = '';
let sessionInstituteName = '';
let sessionUserName = '';

export function setAiSessionInstituteId(instituteId) {
    sessionInstituteId = String(instituteId || '').trim();
}

export function setAiSessionInstituteName(instituteName) {
    sessionInstituteName = String(instituteName || '').trim();
}

export function getAiSessionInstituteId() {
    return sessionInstituteId;
}

export function setAiSessionUserId(userId) {
    sessionUserId = String(userId || '').trim();
}

export function setAiSessionUserName(userName) {
    sessionUserName = String(userName || '').trim();
}

export function getAiSessionUserId() {
    return sessionUserId;
}

/** Resolve a stable user id from dashboard userinfo. */
export function resolveAiUserId(userinfo) {
    return String(
        userinfo?.id ||
            userinfo?.userid ||
            userinfo?.user_id ||
            userinfo?.uid ||
            userinfo?.email ||
            '',
    ).trim();
}

export function aiConversationStorageKey(userId) {
    const id = String(userId || '').trim();
    return id ? `aiConversationId:${id}` : 'aiConversationId';
}

export function aiInstituteHeaders(instituteId, userId) {
    const inst = String(instituteId || sessionInstituteId || '').trim();
    const user = String(userId || sessionUserId || '').trim();
    const instName = sessionInstituteName;
    const userName = sessionUserName;
    const headers = {};
    if (inst) headers['x-tabex-institute-id'] = inst;
    if (user) headers['x-tabex-user-id'] = user;
    if (instName) headers['x-tabex-institute-name'] = encodeURIComponent(instName);
    if (userName) headers['x-tabex-user-name'] = encodeURIComponent(userName);
    return headers;
}
